import { components } from "@certn/api/generated-schemas/client-portal";
import { Container } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import React from "react";
import { useTranslation } from "react-i18next";

import { PaymentCard } from "./components/PaymentCard";
import { EmptyState } from "../../components/empty-state/EmptyState";

export interface CardProps {
  id: string;
  created: string;
  brand: string | null;
  number: string | null;
  expiry_date: string | null;
  owner: string | null;
  issuer: string | null;
  title: string | null;
  status: components["schemas"]["PaymentProfileListStatusEnum"];
}
interface PaymentProfilesProps {
  paymentProfiles: CardProps[];
  statusFilter: "ACTIVE" | "INACTIVE";
  mutate: () => void;
}

export function PaymentProfilesTab(props: PaymentProfilesProps) {
  const { paymentProfiles, statusFilter, mutate } = props;
  const { t } = useTranslation();

  const filteredPaymentProfiles = paymentProfiles.filter(
    (profile) => profile.status === statusFilter && profile.number
  );

  if (filteredPaymentProfiles.length === 0) {
    return (
      <EmptyState
        illustration="wallet-cards"
        description={
          statusFilter === "ACTIVE"
            ? t("You have no active payment profiles.")
            : t("You have no archived payment profiles.")
        }
      />
    );
  }

  return (
    <Container
      layout="narrow"
      className={css({ rowGap: "var(--space-3)" })}
      testID="payment-card-container"
    >
      {filteredPaymentProfiles.map((item) => {
        return (
          <PaymentCard
            brand={item.brand || ""}
            number={item.number || ""}
            expiryDate={item.expiry_date || ""}
            owner={item.owner || ""}
            issuer={item.issuer || ""}
            title={item.title || ""}
            id={item.id || ""}
            key={item.id || ""}
            isArchived={statusFilter === "INACTIVE"}
            mutate={mutate}
          />
        );
      })}
    </Container>
  );
}
